<template>
  <section>
    <b-container class="container-small pb-25">
      <b-card>
        <div class="d-flex justify-content-between">
          <b-card-title class="mb-50">
            {{ wrapper.name }}
          </b-card-title>
          <p class="mb-0">
            {{ wrapper.totalResponses }}
            {{ $tk('ClientPortal.Survey.TotalResponses') }}
          </p>
        </div>
        <b-button
          variant="primary"
          :to="`/${this.$route.params.accountId}/surveys/edit/${this.$route.params.surveyId}`"
          size="sm"
        >
          <GjIcon
            class="mr-50"
            name="Edit"
          />
          {{ $tk('ClientPortal.Survey.EditSurvey') }}
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          size="sm"
          @click="exportSurvey"
        >
          <GjIcon
            class="mr-50"
            name="Redirect"
          />
          {{ $tk('ClientPortal.Survey.Export') }}
        </b-button>
      </b-card>
      <b-card
        v-for="(question,questionIndex) in wrapper.questions"
        :key="questionIndex"
        class="mb-1"
      >
        <div class="d-flex justify-content-between">
          <b-card-title class="mb-50 mr-1 text-break">
            {{ question.name }}
          </b-card-title>
          <p
            class="mb-0 text-right"
          >
            {{ question.totalResponses }} {{ $tk('ClientPortal.Survey.TotalResponses') }}
          </p>
        </div>
        <b-row>
          <b-col
            sm="12"
            style="min-height:350px;"
          >
            <div
              v-if="loadingChartStats"
              class="text-center"
            />
            <apexchart
              v-else
              ref="realtimeChart"
              type="bar"
              height="350"
              width="100%"
              :options="question.chartStats.options"
              :series="question.chartStats.series"
            />
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import notification from '@/mixins/toastification'
import SurveysService from '@/api/client/surveys.service'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    GjIcon,
    apexchart: VueApexCharts,
  },
  mixins: [notification],
  data() {
    return {
      wrapper: {},
      loading: true,
      loadingChartStats: true,
      surveyId: 0,
      options: {
        chart: {
          id: 'vuechart-example',
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        },
      },
      series: [{
        name: 'series-1',
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      }],
    }
  },
  watch: {
    '$route.params.accountId': 'fetchData',
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      this.loadingChartStats = true
      try {
        const response = await SurveysService.getSurveyDetails(this.$route.params.surveyId, this.$route.params.accountId)
        if (response.message === 'Redirect to surveys') {
          this.$router.push({ name: 'surveys' })
          return
        }
        this.wrapper = response
        this.fetchChartStats()
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loading = false
      }
    },
    async fetchChartStats() {
      this.loadingChartStats = true
      try {
        const chartData = await SurveysService.getChart(this.$route.params.surveyId, this.$route.params.accountId)
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.wrapper.questions.length; i++) {
          const question = this.wrapper.questions[i]
          this.setChartData(question, chartData[i])
        }
      } catch (error) {
        this.error(error.message)
      } finally {
        this.loadingChartStats = false
      }
    },
    setChartData(question, chartData) {
      question.chartStats = {
        options: {
          chart: {
            width: '100%',
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '10%',
              barHeight: '70%',
              distributed: false,
              rangeBarOverlap: true,
              rangeBarGroupRows: false,
              colors: {
                ranges: [{
                  from: 0,
                  to: 0,
                  color: undefined,
                }],
                backgroundBarColors: [],
                backgroundBarOpacity: 1,
                backgroundBarRadius: 0,
              },
              dataLabels: {
                position: 'top',
                maxItems: 100,
                hideOverflowingLabels: true,
              },
            },
          },
          xaxis: {
            categories: chartData.xAxisLabels,
          },
          tooltip: {
            y: {
              formatter: value => value,
            },
          },
        },
        series: [{
          name: '',
          data: chartData.series[0].data,
        }],
      }
      question.totalResponses = this.calculateTotalResponses(chartData.series[0].data)
    },
    calculateTotalResponses(data) {
      let total = 0
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < data.length; i++) {
        total += data[i]
      }
      return total
    },
    async exportSurvey() {
      const response = await SurveysService.export(this.$route.params.surveyId, this.$route.params.accountId)
      const fileName = this.getFileName(this.$route.params.surveyId)
      this.$nextTick(() => { this.downloadFile(response, fileName) })
    },
    getFileName(surveyId) {
      const currentDateTime = new Date()
      const dateTime = `${currentDateTime.getFullYear()}${currentDateTime.getMonth() + 1}${currentDateTime.getDate()}${currentDateTime.getHours()}${currentDateTime.getMinutes()}`
      return `${this.$tk('ClientPortal.Survey.ReportFilePrefix')} ${surveyId} - ${dateTime}.xlsx`
    },
    downloadFile(file, name) {
      const fileURL = window.URL.createObjectURL(new Blob([file]))
      const fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.setAttribute('download', name)
      document.body.appendChild(fileLink)
      fileLink.click()
    },
  },
}
</script>
